import styled from 'styled-components';

const Wrapper = styled.section`
 
  width: 100%;
  min-height: 6vh;
  display: flex;
  align-items: center;

  color: var(--clr-primary-1);
  a {
    color: var(--clr-primary-3);
    padding: 0.5rem;
    transition: var(--transition);
  }
  a:hover {
    color: var(--clr-primary-1);
  }
`;

// background: var(--clr-primary-10);

export default Wrapper;
